// extracted by mini-css-extract-plugin
module.exports = {"default":"ImageRight_default___Knlu","dark":"ImageRight_dark__FzCdz","dark-gradient":"ImageRight_dark-gradient__KfCJp"};